import { render, staticRenderFns } from "./PlanIncome.vue?vue&type=template&id=24e581e2&scoped=true&"
import script from "./PlanIncome.vue?vue&type=script&lang=js&"
export * from "./PlanIncome.vue?vue&type=script&lang=js&"
import style0 from "./PlanIncome.vue?vue&type=style&index=0&id=24e581e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e581e2",
  null
  
)

export default component.exports